import axios from "@/libs/api.request";
// 获取财务分区列表
export const getList = params => {
  return axios.request({
    url: "/finance/FinancialDivision",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/finance/FinancialDivision/${id}`,
    method: "GET"
  });
};
// 删除单个信息
export const del = id => {
  return axios.request({
    url: `/finance/FinancialDivision/${id}`,
    method: "DELETE"
  });
};
// 修改单个信息
export const update = data => {
  return axios.request({
    url: `/finance/FinancialDivision/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增单个信息
export const add = data => {
  return axios.request({
    url: "/finance/FinancialDivision",
    method: "POST",
    data
  });
};
